// path: /chat/openAIUtils.jsx
// MIGRATED TO USE CLOUD FUNCTIONS - API keys now secure on server-side
// This file now proxies all calls to Cloud Functions

import * as CloudFunctions from './openAIUtilsCloudFunctions';

// Import assistant mapping for compatibility
import { titleToAssistantIDMap } from '../assistantMapping';

// Re-export the assistant mapping
export { titleToAssistantIDMap };

// Export all Cloud Functions methods
export const createThread = CloudFunctions.createThread;
export const createMessage = (
  threadId,
  arg2,
  arg3,
  arg4 = null,
  arg5 = null,
  arg6 = [],
) => {
  // Backward compatibility:
  // - New shape: createMessage(threadId, role, content, assistantTitle, resourceId?, fileIds?)
  // - Legacy shape: createMessage(threadId, content, assistantTitle, resourceId?, fileIds?)
  const isRole = arg2 === 'user' || arg2 === 'assistant' || arg2 === 'system' || arg2 === 'tool';

  if (isRole) {
    return CloudFunctions.createMessage(threadId, arg2, arg3, arg4, arg5, arg6);
  }

  return CloudFunctions.createMessage(threadId, 'user', arg2, arg3, arg4, arg5 ?? []);
};
export const createRun = CloudFunctions.createRun;
export const cancelRun = CloudFunctions.cancelRun;
export const listMessages = CloudFunctions.listMessages;
export const createResponse = CloudFunctions.createResponse;
export const createClaudeResponse = CloudFunctions.createClaudeResponse;

// Legacy compatibility - these functions are no longer needed but kept for compatibility
export function initializeOpenAIClient(assistantTitle, resourceId = null, apiKeyOverride = null) {
  console.log('[DEPRECATED] initializeOpenAIClient is deprecated. Using Cloud Functions instead.');
  console.log('Assistant:', assistantTitle, 'ResourceId:', resourceId);
  // Return a dummy object for compatibility
  return {
    beta: {
      threads: {
        create: () => CloudFunctions.createThread(assistantTitle, resourceId),
        messages: {
          create: (threadId, data) => CloudFunctions.createMessage(threadId, data.role, data.content, assistantTitle, resourceId),
          list: (threadId) => CloudFunctions.listMessages(threadId, assistantTitle, resourceId),
        },
        runs: {
          stream: (threadId, data) => {
            // Return a stream-like object
            const handlers = { textDelta: [], end: [], error: [] };
            
            const streamObj = {
              on: (event, handler) => {
                if (handlers[event]) {
                  handlers[event].push(handler);
                }
                return streamObj;
              }
            };
            
            // Start the stream using Cloud Functions
            CloudFunctions.createRun(
              threadId,
              data.assistant_id,
              (msg) => {
                if (msg.text === 'END_TOKEN') {
                  handlers.end.forEach(h => h());
                } else {
                  handlers.textDelta.forEach(h => h({ value: msg.text }));
                }
              },
              (error) => {
                handlers.error.forEach(h => h(error));
              },
              assistantTitle,
              resourceId
            );
            
            return streamObj;
          },
          cancel: (threadId, runId) => CloudFunctions.cancelRun(threadId, runId, assistantTitle, resourceId),
        },
      },
    },
  };
}

// For backward compatibility
export function getFallbackApiKeys() {
  console.log('[DEPRECATED] getFallbackApiKeys is no longer needed with Cloud Functions');
  return [];
}

// Stub for createRunNoStream (non-streaming version)
export async function createRunNoStream(threadId, assistantId, assistantTitle, resourceId = null) {
  console.log('[DEPRECATED] createRunNoStream - using Cloud Functions');
  // For now, just return a placeholder
  // The actual implementation would need to be in Cloud Functions
  return { id: 'run_placeholder', status: 'completed' };
}

// Stub for getRunStatus
export async function getRunStatus(threadId, runId, assistantTitle, resourceId = null) {
  console.log('[DEPRECATED] getRunStatus - using Cloud Functions');
  // Return a placeholder status
  return { id: runId, status: 'completed' };
}

export default {
  createThread,
  createMessage,
  createRun,
  createRunNoStream,
  getRunStatus,
  cancelRun,
  listMessages,
  createResponse,
  initializeOpenAIClient,
};
